<style scoped lang="scss">
.small-card {
  .box-card {
    margin-bottom: 20px;
    ::v-deep.el-card__header {
      padding: 16px 20px 0 24px;
      border-bottom: 1px solid #f0f0ff;
      div {
        .title {
          font-size: 14px;
          color: #262626;
          font-weight: 600;
        }
        .btns {
          float: right;
        }
      }
    }
  }
}
.datas-container {
  .goods-box {
    //  margin-right:-12px;
    .goods-list {
      overflow: hidden;
      zoom: 1;
      .item {
        border: 1px solid rgba(0, 0, 0, 0.05);
        padding: 4px;
        margin-bottom: 12px;
        margin-right: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        width: 40%;
        float: left;
        .num {
          position: absolute;
          left: 0;
          top: 0;
          width: 16px;
          height: 16px;
          background: rgba(0, 0, 0, 0.25);
          text-align: center;
          line-height: 16px;
          color: #fff;
          font-size: 12px;
        }
        &-type {
          width: 32px;
          height: 32px;
          color: #fff;
          font-size: 17px;
          text-align: center;
          line-height: 32px;
          &.cash {
            background: #ec808d;
          }
          &.discount {
            background: #81d3f8;
          }
          &.gift {
            background: #facd91;
          }
        }
        &-info {
          flex: 1;
          padding-left: 20px;
          .title {
            font-size: 14px;
            color: #262626;
            height: 22px;
            line-height: 22px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .sku {
            font-size: 12px;
            color: #262626;
            height: 22px;
            line-height: 22px;
          }
        }
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}
</style>
<template>
  <div>
    <SpCardContent
      title="优惠券管理"
      class="smallCard"
      :btns="
        disabled
          ? null
          : [
            { key: 'clear', name: '清空', type: 'text' },
            { key: 'edit', name: '编辑优惠券', type: 'primary' }
          ]
      "
      @btnsOption="managerOperate"
    >
      <div class="meter-text">
        已选择 {{ meters.selectCouponData.length }} 张优惠券，最多选择9张，拖动以排序
      </div>
      <div class="datas-container">
        <div
          v-if="meters"
          class="goods-box"
        >
          <ul
            v-if="meters.selectCouponData"
            class="goods-list"
          >
            <draggable
              v-model="meters.selectCouponData"
              @start="onStart"
              @end="onEnd"
            >
              <li
                v-for="(item, index) in meters.selectCouponData"
                :key="item.card_id"
                class="item"
              >
                <div
                  class="item-type"
                  :class="item.card_type"
                >
                  {{ item.card_type_val }}
                </div>
                <div class="item-info">
                  <h4 class="title">
                    {{ item.title }}
                  </h4>
                  <!-- <p
                    v-if="item.sku != ''"
                    class="sku"
                  >
                    {{ item.sku }}
                  </p> -->
                </div>
                <span class="num">{{ index + 1 }}</span>
              </li>
            </draggable>
          </ul>
        </div>
      </div>
    </SpCardContent>
    <!-- 选择优惠券 -->
    <CouponSelect
      :coupon-visible="meters.couponVisible"
      :select-data="meters.selectCouponData"
      @closeCouponDialog="closeCouponDialog"
      @chooseCoupon="chooseCoupon"
    />
  </div>
</template>

<script>
import CouponSelect from '@/components/couponSelect'
// 第三方组件
import draggable from 'vuedraggable'

export default {
  components: {
    CouponSelect,
    draggable
  },
  props: {
    meters: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    meters (nVal, oVal) {
      console.log('nVal------->', nVal)
    }
  },
  mounted () {
    console.log('222------>', this.meters)
  },
  methods: {
    managerOperate (key) {
      if (key === 'clear') {
        this.meters.selectGoodsData = []
      }
      if (key === 'edit') {
        console.log('this.meters', this.meters)
        this.meters.couponVisible = true
      }
    },
    // 关闭优惠券对话框
    closeCouponDialog () {
      this.meters.couponVisible = false
    },

    // 选择优惠券
    chooseCoupon (selectdata, ids) {
      console.log('selectdata---->', selectdata)

      if (this.meters.time_type !== 3) {
        let errormsg = this.meters.time_type === 1 ? '已结束' : '正在进行中'
        this.$message.error('目标' + errormsg + '不可编辑')
        return
      }
      if (selectdata.length > 9) {
        this.$message.error('最多选择9张券')
      } else if (0 < selectdata.length <= 9) {
        this.meters.selectCouponData = selectdata
        this.meters.coupon = ids
        this.meters.couponVisible = false
      } else {
        this.meters.selectCouponData = []
        this.meters.coupon = ''
        this.meters.couponVisible = false
      }
    },

    // 删除图片
    removePicsImg: function (i) {
      this.meters.pics.splice(i, 1)
    },

    // 拖拽绑定事件
    onStart (evt) {
      console.log(evt)
    },
    onEnd (evt) {
      console.log(evt)
    }
  }
}
</script>
